import { MapCheckIcon } from './MapCheckIcon';

/**
 * author: mocking-mike
 * id 39D94D7A-D161-409F-8FFC-889474A4DCE9
 * name map-check
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-check.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const MapTickIcon = MapCheckIcon;
export default MapTickIcon